export default {
  downloadFile(file, contentType) {
    const byteCharacters = atob(file.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: contentType});

    if (navigator.msSaveBlob) {
      // IE 10+
      window.navigator.msSaveBlob(blob, file.fileName);
    } else {
      const a = document.createElement('a');
      const fileURL = URL.createObjectURL(blob);
      a.href = fileURL;
      a.download = file.fileName;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
    }
  }

};